import { render, staticRenderFns } from "./PreliminaryAssessment.vue?vue&type=template&id=f88e4ea6&scoped=true"
import script from "./PreliminaryAssessment.vue?vue&type=script&lang=js"
export * from "./PreliminaryAssessment.vue?vue&type=script&lang=js"
import style0 from "./PreliminaryAssessment.vue?vue&type=style&index=0&id=f88e4ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88e4ea6",
  null
  
)

export default component.exports